import AuthWSClient from './AuthWSClient';
import NoAuthWSClient from './NoAuthWSClient';

export const authWSClient = new AuthWSClient();
export const noAuthWSClient = new NoAuthWSClient();
